import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import {
  AFFILIATES_APPROVED_TRACKERS_LIST_PERMISSIONS,
} from '@modules/affiliates-approved/submodules/trackers-settings/submodules/trackers-list/constants';
import {
  ADMIN_AFFILIATE_TRACKERS_SETTINGS_TRACKERS_DEAL_MAIN_ROUTE_NAME,
} from '@modules/affiliates-approved/submodules/trackers-settings/submodules/trackers-list/submodules/tracker-deal-changes/constants';
import { AppModule } from '@modules/core/plugins/AppModule';

import {
  ADMIN_AFFILIATE_TRACKERS_SETTINGS_TRACKERS_HISTORY_CHANGES_EDIT_ROUTE_NAME,
  TRANSLATION_GROUP_AFFILIATES_TRACKERS_SETTINGS_TRACKERS_HISTORY_CHANGES_EDIT,
} from './constants';
import { getTranslationKeys } from './translations';

export class AffiliatesApprovedTrackersSettingsTrackerHistoryChangesEditModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addChildRoute(ADMIN_AFFILIATE_TRACKERS_SETTINGS_TRACKERS_DEAL_MAIN_ROUTE_NAME, {
      name: ADMIN_AFFILIATE_TRACKERS_SETTINGS_TRACKERS_HISTORY_CHANGES_EDIT_ROUTE_NAME,
      path: ':merchantId/history/:itemId',
      permission: AFFILIATES_APPROVED_TRACKERS_LIST_PERMISSIONS.HISTORY_CHANGES_EDIT,
      component: () => import('./pages/TrackerHistoryChangesEditPage/TrackerHistoryChangesEditPage.vue'),
    });
  }

  addMenu(): void {}

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_AFFILIATES_TRACKERS_SETTINGS_TRACKERS_HISTORY_CHANGES_EDIT, getTranslationKeys);
  }
}
